import { isSyndicatedReviewIncentivized, replaceIncentivizedReviewText } from '../utils/reviewsRegex';
import { DEFAULT_SYNDICATED_INCENTIVIZED_REVIEWS_BADGE_NAME, DEFAULT_SYNDICATED_INCENTIVIZED_REVIEWS_BADGES } from '../constants/reviews';
import type { Badges } from '../types';
import type { Review } from '~~/shared/globalTypes/reviews';
import { provideReviewDefaults } from '~/modules/reviews/utils/provideReviewDefaults';

const assignDefaultReviewPropValues = (review: Review): Review => ({
  ...review,
  reviewText: provideReviewDefaults(review, 'reviewText', ''),
  title: provideReviewDefaults(review, 'title', ''),
  photos: provideReviewDefaults(review, 'photos', [], false),
  videos: provideReviewDefaults(review, 'videos', [], false),
});

/**
 * include badges data if incentivized badging data is not already included
 */
const getIncentivizedBadgeData = (badges: Badges, badgesOrder: string[]) => ({
  badges: {
    ...badges,
    ...DEFAULT_SYNDICATED_INCENTIVIZED_REVIEWS_BADGES,
  },
  badgesOrder: [...badgesOrder, DEFAULT_SYNDICATED_INCENTIVIZED_REVIEWS_BADGE_NAME],
});

function parseReview(review: Review): Review {
  if (!review) return review;
  const parsedReview = assignDefaultReviewPropValues(review);
  const {
    syndicated = false,
    reviewText = '',

    // badges data
    badges = {},
    badgesOrder = [],

    dataValuesJSONMap = {},
    // use keys as order
  } = parsedReview;

  const dataValuesJSONMapKeys = Object.keys(dataValuesJSONMap);

  return Object.assign(parsedReview, {
    // { incentivizedReview, reviewText, badges, badgesOrder }
    ...(syndicated &&
      isSyndicatedReviewIncentivized(reviewText) && {
        // is syndicated and incentivized bracket text is found in reviewText
        // enables the incentivized badge
        incentivizedReview: true,
        // remove the text in between the square brackets from the reviewText
        reviewText: replaceIncentivizedReviewText(reviewText),

        // { badges, badgesOrder }
        ...(!badgesOrder.includes(DEFAULT_SYNDICATED_INCENTIVIZED_REVIEWS_BADGE_NAME) && getIncentivizedBadgeData(badges, badgesOrder)),
      }),

    ...(dataValuesJSONMapKeys.length > 0 && {
      contextDataValues: { ...dataValuesJSONMap },
      contextDataValuesOrder: dataValuesJSONMapKeys,
    }),
  });
}

export default function parseReviewsData(reviews: Review[]): Review[] {
  return reviews.map(parseReview);
}
